// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610140356/js/" + chunkId + "." + {"44":"bb550b4d","225":"c3a0ff06","481":"d48d51bc","486":"eeb31369","770":"f217d56b"}[chunkId] + ".0.7597125736832261.chunk.js";
};